import { PlayerLayout } from '@core/player/types';
import { ILiveStreamChatInputState } from './types';
export const initialState = {
    actions: {},
    availableHeight: 0,
    availableWidth: 0,
    currentVideoAdId: null,
    currentSubtitlesId: null,
    expandedProduct: null,
    flowLinkId: '',
    hasAutoplay: true,
    hasHydratedProducts: {},
    initialLayout: PlayerLayout.DEFAULT,
    isCartRevealed: false,
    isDesktop: false,
    isIMAActive: false,
    isInteractable: true,
    isLoaded: false,
    visibleInteractionIds: [],
    activeInteractionIds: [],
    expandedInteractionId: null,
    isMinimized: false,
    isProductDescriptionExpanded: false,
    isProductModalExpanded: null,
    isQRModeEnabled: false,
    isTapToUnmuteVisible: false,
    isVideoEngaged: false,
    isVideoEngagedV2: false,
    isVideoMuted: true,
    isVisible: false,
    ivsLowLatencyEnabled: true,
    ivsQualityEnabled: undefined,
    ivsState: {
        playerState: null,
        lastPlayerEvent: null,
        lastPlayerError: null,
    },
    lastCartUpdate: 0,
    layout: PlayerLayout.FULLSCREEN,
    liveStreamActions: {},
    liveStreamBotGreeting: {},
    liveStreamError: null,
    liveStreamWSError: null,
    liveStreamEvents: {},
    liveStreamMessages: {},
    liveStreamPinnedMessage: {},
    liveStreamProducts: {},
    liveStreamRunningAnnouncements: {},
    liveStreamState: null,
    liveStreamTemporaryChatHighlightMessage: {},
    liveStreamUsername: '',
    liveStreamChatInputState: ILiveStreamChatInputState.PUBLIC,
    liveStreams: {},
    nextVideoAdId: null,
    subtitlesEnabled: false,
    uiZoom: 1,
    usernameChangeRequest: {
        ref: '-1',
        status: null,
        username: '',
        message: '',
    },
    video: null,
    videoAds: {},
    videoAdsAll: {},
    videoId: '',
    videoProducts: {},
    liveStreamMessageRateLimit: {},
    // The initial state is no longer representing the entire player state after
    // the introduction of slices. However, we have to type it as IPlayerContext
    // because it's used as the initial state for the entire store in many unit
    // tests. Consider refactoring those tests and remove this cast.
};
